import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

function AuthPage({ onLogin }) {
  const [authView, setAuthView] = useState('login'); // 'login' sau 'register'

  const handleRegister = () => {
    // Înregistrarea a fost realizată cu succes
    // Utilizatorul va fi redirecționat către pagina de login
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      {/* Conținut principal pentru utilizatorii neautentificați */}
      <div className="flex-grow flex items-center justify-center">
        <div className="text-center max-w-lg px-4 py-8">
          <h1 className="text-3xl font-bold mb-4 text-white">Chatbot cu Krakiun</h1>
          <p className="mb-8 text-gray-300">
            Aplicație de chat AI bazată pe modele locale. Autentifică-te sau înregistrează-te pentru a continua.
          </p>
          
          {authView === 'login' 
            ? <LoginForm onLogin={onLogin} switchToRegister={() => setAuthView('register')} />
            : <RegisterForm onRegister={handleRegister} switchToLogin={() => setAuthView('login')} />
          }
        </div>
      </div>
      
      {/* Footer pentru utilizatorii neautentificați */}
      <footer className="bg-gray-800 py-4 text-center text-gray-300 border-t border-gray-700">
        <p>© 2024 krakiun lab. Toate drepturile rezervate.</p>
      </footer>
    </div>
  );
}

export default AuthPage; 